var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"id":"base"}},[(!_vm.hideAppBar)?_c('AppBar',{attrs:{"isDrawerHidden":_vm.hideDrawer,"showHome":_vm.showHome}}):_vm._e(),_c('v-main',[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }